const CollapsibleContainer = ({children, expanded, orientation = 'vertical'}) => {
    var containerClass = orientation === 'horizontal' ? 'collapsible-h' : 'collapsible-v';
    if(expanded) containerClass = `${containerClass} active`;

    return (
        <div className={containerClass}>
            <div>
                {children}
            </div>
        </div>
    )
}

export default CollapsibleContainer;